<!--
  - Copyright (c) 2023. Haodong JU
  -->

<template>
  <div>
    <ik-data-table
      :model="model"
      :required-date-value="$parent.dateRange"
      :use-action="false"
      :use-default-action="false"
      entity-name="TimeRangeStatistics"
      icon="mdi-cards"
    >
      <template #right="{tableItems}">
        <v-btn
          color="amber lighten-4 black--text"
          elevation="0"
          @click="download(tableItems)"
        >
          <v-icon left>
            mdi-export
          </v-icon>
          {{ $t('export') }}
        </v-btn>
      </template>
      <template #footer>
        <!-- Display information about the hourly report here if needed -->
      </template>
    </ik-data-table>
  </div>
</template>

<script>
import IkDataTable from '@/plugins/EntityFrameWork/IkDataTable.vue'
import hourlyReport from '@/model/dataLayer/api/statistic/hourlyReport'
import ExportJsonExcel from 'js-export-excel'

export default {
  name: 'HourlyReport',
  components: {
    IkDataTable
  },
  data () {
    return {
      model: hourlyReport
    }
  },
  watch: {
    '$parent.dateRange': {
      handler: function (val) {

      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    async download (items) {
      const sheetHeader = ['起始时间', '结束时间', '销售数量', '税率', '总订单数量', '订单完成数量', '总金额']
      const sheetFilter = ['起始时间', '结束时间', '销售数量', '税率', '总订单数量', '订单完成数量', '总金额']
      const sheetData = items.map(it => {
        return {
          起始时间: it.startsAt,
          结束时间: it.endsAt,
          销售数量: it.sumDODCount,
          税率: it.taxes,
          总订单数量: it.openCount,
          订单完成数量: it.closedCount,
          总金额: it.sumTotal
        }
      })

      const option = {
        fileName: '时段统计',
        datas: [
          {
            sheetData,
            sheetName: '时段统计',
            sheetFilter,
            sheetHeader
          }
        ]
      }

      const toExcel = new ExportJsonExcel(option)
      toExcel.saveExcel()
    }
  }
}
</script>

<style scoped>

</style>
